import React from "react";
import { useNavigate } from "react-router-dom";
import CorporateAdvisorycomponents from "./CorporateAdvisorycomponents";
import CallToAction from "./CallToAction";

const CorporateAdvisoryInfo = () => {
    const navigate = useNavigate();

    return (
        <>
            <div className="other-pages-main-section corporate-advisory-fin">
                <h2 className="other-pages-title">Corporate Advisory & Virtual CFO </h2>
                <p>
                    <span onClick={() => navigate("/")} style={{ cursor: "pointer" }}>Home</span> /
                    <span onClick={() => navigate("/corporate-advisory-virtual-cfo")} style={{ cursor: "pointer" }}>Corporate Advisory & Virtual CFO</span>
                </p>
            </div>
            <CorporateAdvisorycomponents />
            <CallToAction />
        </>
    );
};

export default CorporateAdvisoryInfo;
